import { QRCode } from '@getstep/qrcode-dom'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'

import { isFundingPage } from '../../../lib/utils/page'
import { GetStepButton } from '../../get-step-button'
import { Markdown } from '../../markdown'
import { Desktop, Mobile } from '../../responsive'
import styles from './footer-cta.module.scss'

/**
 * This CTA is appended above the footer links on every page. The text and the
 * QR code are static.
 */
export const FooterCta: FunctionComponent = () => {
    const router = useRouter()

    const isFundingFlow = isFundingPage(router.pathname)

    const heading = 'get money smart. **get ahead**'

    return (
        <div className={styles['container']}>
            <div className={styles['heading-container']}>
                <Markdown
                    tag='h3'
                    typeStyle={{
                        _: 'heading-lg',
                        md: 'heading-3xl',
                    }}
                    boldColor='primary'
                    markdown={heading}
                />
            </div>
            <Desktop>
                <QRCode
                    size={100}
                    width='100'
                    height='100'
                    value={
                        process.env.NEXT_PUBLIC_ORGANIC_DOWNLOAD_URL as string
                    }
                    backgroundColor='transparent'
                    quietZone={0}
                    className={styles['qr-code']}
                />
            </Desktop>
            <Mobile visible={!isFundingFlow}>
                <GetStepButton />
            </Mobile>
        </div>
    )
}
